

export const state = {
    user: null,
};